import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Receipt } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (v) => Number(v || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

/** Factures & Reçus ESS : reçus émis automatiquement sur les mandats SEPA. */
export default function RecusMandatsSEPA() {
  const { getAuthHeader } = useAuth();
  const [items, setItems] = useState(null);
  const [tous, setTous] = useState(false);
  useEffect(() => {
    axios.get(`${API}/sepa-stripe/admin/recus-mandats`, { headers: getAuthHeader() })
      .then(({ data }) => setItems(data.recus || [])).catch(() => setItems([]));
  }, [getAuthHeader]);
  const ouvrir = async (r) => {
    try {
      const res = await axios.get(`${API}/comptabilite/documents/${r.ged_id}/download`, { headers: getAuthHeader(), responseType: 'blob' });
      window.open(URL.createObjectURL(res.data), '_blank');
    } catch { toast.error('Reçu indisponible'); }
  };
  const liste = (items || []).filter((r) => tous || r.derniere);
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="recus-mandats-sepa">
      <div className="mb-3 flex items-center gap-3">
        <Receipt className="h-5 w-5 text-[#0a3d62]" />
        <h3 className="flex-1 text-base font-bold text-[#0a3d62]">Reçus des mandats SEPA <span className="ml-1 text-xs font-normal text-slate-500">enregistrés automatiquement à chaque encaissement</span></h3>
        <label className="flex items-center gap-1.5 text-xs text-slate-600"><input type="checkbox" checked={tous} onChange={() => setTous(!tous)} data-testid="recus-mandats-versions" /> Afficher les versions archivées</label>
      </div>
      {!items ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : liste.length === 0 ? (
        <p className="text-sm text-slate-500">Aucun reçu de mandat pour l&apos;instant.</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500"><tr><th className="p-2">N° reçu</th><th className="p-2">Membre</th><th className="p-2">Mandat</th><th className="p-2">Réglé</th><th className="p-2">Solde</th><th className="p-2">Statut</th><th className="p-2" /></tr></thead>
          <tbody>
            {liste.map((r) => (
              <tr key={r.ged_id} className="border-t border-slate-100" data-testid={`recu-mandat-${r.ged_id}`}>
                <td className="p-2 font-mono text-xs">{r.numero}{!r.derniere && <span className="ml-1 text-slate-400">(archivé)</span>}</td>
                <td className="p-2"><b>{r.membre_nom}</b><br /><span className="text-xs text-slate-500">{r.raison_sociale}</span></td>
                <td className="p-2 text-xs">{r.dispositif} · {r.rum}<br /><span className="text-slate-500">{r.document}</span></td>
                <td className="p-2">{eur(r.paye)}</td>
                <td className="p-2">{eur(r.reste)}</td>
                <td className="p-2"><span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${r.acquitte ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>{r.acquitte ? 'ACQUITTÉ' : 'Acompte'}</span></td>
                <td className="p-2"><button type="button" onClick={() => ouvrir(r)} className="rounded border border-slate-300 px-2 py-1 text-xs hover:bg-slate-50" data-testid={`recu-mandat-voir-${r.ged_id}`}>Voir</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
